import { OVERRIDE_MODES, OVERRIDE_TYPES } from "../../enums/override_enum";
import { asKw } from "../../scripts/utils";

function explainMode(mode, value) {
  if (mode === OVERRIDE_MODES.CONTROL_LIMIT.value) {
    return "Limit the max controlled power to";
  } else if (mode === OVERRIDE_MODES.FLEX.value) {
    if (value === 0) return "Remain idle ";
    return value < 0 ? "Discharge with" : "Charge with";
  } else if (mode === OVERRIDE_MODES.GRID.value) {
    return "Try to reach a grid value of";
  } else if (mode === OVERRIDE_MODES.CURTAILMENT_CONSUMPTION.value) {
    return "Try to curtail consumption with";
  } else if (mode === OVERRIDE_MODES.CURTAILMENT_PRODUCTION.value) {
    return "Try to reduce production with";
  }
}

function explainValue(value, type, limits) {
  const [max_inj, max_off] = limits;
  if (type === OVERRIDE_TYPES.POWER.value) {
    return `${asKw(Math.abs(value))}kW`;
  } else if (type === OVERRIDE_TYPES.FRACTION.value) {
    const limit = value < 0 ? max_inj : max_off;
    return `${asKw((value / 100) * Math.abs(limit))}kW`;
  }
}

function explainDevice(device_id, target) {
  if (device_id === undefined) {
    return "over all devices";
  } else {
    return `on ${target}`;
  }
}

function explainPeriod(from, to, period_type) {
  if (period_type !== "Custom") return period_type.toLowerCase();

  return explainCustomPeriod(from, to);
}

function explainCustomPeriod(from, to) {
  if (!from && !to) {
    return "until override is cleared";
  }
  if (from && !to) {
    const d = from.toDate();
    return (
      "from " +
      ("0" + d.getDate()).slice(-2) +
      "-" +
      ("0" + (d.getMonth() + 1)).slice(-2) +
      "-" +
      d.getFullYear() +
      " " +
      ("0" + d.getHours()).slice(-2) +
      ":" +
      ("0" + d.getMinutes()).slice(-2) +
      " until cleared"
    );
  }
  const d = from.toDate();
  const t = to.toDate();
  return (
    "from " +
    ("0" + d.getDate()).slice(-2) +
    "-" +
    ("0" + (d.getMonth() + 1)).slice(-2) +
    "-" +
    d.getFullYear() +
    " " +
    ("0" + d.getHours()).slice(-2) +
    ":" +
    ("0" + d.getMinutes()).slice(-2) +
    " until " +
    ("0" + t.getDate()).slice(-2) +
    "-" +
    ("0" + (t.getMonth() + 1)).slice(-2) +
    "-" +
    d.getFullYear() +
    " " +
    ("0" + t.getHours()).slice(-2) +
    ":" +
    ("0" + t.getMinutes()).slice(-2)
  );
}

export default function explainOverride(override, target, period_type, limits) {
  return (
    explainMode(override.mode, override.value) +
    " " +
    explainValue(override.value, override.type, limits) +
    " " +
    explainDevice(override.device_id, target) +
    " " +
    explainPeriod(override.valid_from, override.valid_to, period_type)
  );
}
